import BaseServices from "../base/BaseServices";

const PREFIX_SERVICES = "qlbh/request-digital-certificate-personal/";

const getListIndex = async (data: object) => {
    const requestDigital = await BaseServices.request(
        PREFIX_SERVICES + "index",
        data,
        "GET"
    );
    return requestDigital;
};
const store = async (data: object) => {
    const requestDigital = await BaseServices.request(
        PREFIX_SERVICES + "store",
        data,
        "POST"
    );
    return requestDigital;
};
const update = async (id, data) => {
    const requestDigital = await BaseServices.request(
        PREFIX_SERVICES + "update",
        { id_request: id, ...data },
        "PUT"
    );
    return requestDigital;
};

const previewRequestPersonal = async id =>{
    const requestDigital = await BaseServices.request(
        PREFIX_SERVICES + "preview-request-personal/" + id,
        {},
        "GET"
    );
    return requestDigital;
};
const getModelToUpdate= async id =>{
    const requestDigital = await BaseServices.request(
        PREFIX_SERVICES + "get-model-to-update/" +id ,
        {},
        "GET"
    );
    return requestDigital;
};

const getListCateServicePackage = async (type_search,type, obj,type_device) => {
    const listCate = await BaseServices.request(
        PREFIX_SERVICES + "get-cate-service-package",
        {type_search,type, obj, type_device},
        "GET"
    );
    return listCate;
};
const deleteRequest = async (id, ) => {
    const requestDigital = await BaseServices.request(
        PREFIX_SERVICES + "delete",
        { id_request: id },
        "DELETE"
    );
    return requestDigital;
};
const generateFile = async (data: object) => {
    const requestDigital = await BaseServices.request(
        PREFIX_SERVICES + "gen-file",
        data,
        "POST"
    );
    return requestDigital;
};
const getFilePassport = (id) =>{
    const file = BaseServices.request(
        PREFIX_SERVICES + `get-file-passport/${id}`,
        {},
        "GET"
    );
    return file;
};
const getFileRegister = (id) =>{
    const file = BaseServices.request(
        PREFIX_SERVICES + `get-file-register/${id}`,
        {},
        "GET"
    );
    return file;
};
const getFileDk02 = (id) =>{
    const file = BaseServices.request(
        PREFIX_SERVICES + `get-file-dk02/${id}`,
        {},
        "GET"
    );
    return file;
};
const getFileDk03 = (id) =>{
    const file = BaseServices.request(
        PREFIX_SERVICES + `get-file-dk03/${id}`,
        {},
        "GET"
    );
    return file;
};
const getFileOrganization = (id) =>{
    const file = BaseServices.request(
        PREFIX_SERVICES + `get-file-organization/${id}`,
        {},
        "GET"
    );
    return file;
};
const getInfo = (passport, object, idenType) =>{
    const file = BaseServices.request(
        PREFIX_SERVICES + `getInfo`,
        {passport, object, idenType},
        "POST"
    );
    return file;
};

const getListCateServicePackagePersonal = async (type_search, type) => {
    const listCate = await BaseServices.request(
        PREFIX_SERVICES + "get-list-cate-service-package",
        {type_search, type},
        "GET"
    );
    return listCate;
};
const getProvince = () =>{
    const result =  BaseServices.request(
            PREFIX_SERVICES+ 'getProvince',
        {},
        "GET"
    );
    return result
};
const getDistrictByProvince = async (provinceCode) => {
    const result = await BaseServices.request(
        PREFIX_SERVICES + 'getDistrictByProvinceCode',
        {provinceCode},
        "GET"
    );
    return result;
};
const getRequestBySerial = async (serial_cts) => {
    const result = await BaseServices.request(
        PREFIX_SERVICES + "getRequestBySerial",
        {serial_cts},
        "GET"
    );
    return result;
};
export const RequestDigitalCertificatePersonalServices = {
    store,
    update,
    getListIndex,
    getModelToUpdate,
    previewRequestPersonal,
    getListCateServicePackage,
    deleteRequest,
    generateFile,
    getFilePassport,
    getFileOrganization,
    getInfo,
    getFileRegister,
    getFileDk02,
    getFileDk03,
    getListCateServicePackagePersonal,
    getProvince,
    getDistrictByProvince,
    getRequestBySerial
};
